module.exports = __webpack_public_path__ + "static/media/sk_swiper.d0d732fb.jpg";